module.exports = __webpack_public_path__ + "static/media/ic_orders_grey.50d59b94.svg";